import React from 'react';
import _ from 'lodash';
import update from 'immutability-helper';
import ImageUploaderContainer from '../ImageUploaderContainer';
import IconImages from 'material-ui/svg-icons/image/collections';
import styled from 'styled-components';
import { Slider, Toggle, SelectField, MenuItem, FlatButton, TextField, Popover, Divider } from 'material-ui';
import Subheader from 'material-ui/Subheader';
const C_LAYER_DEFAULT = {
    scale: 1.0,
    translateX: 50,
    translateY: 50,
    opacity: 1.0,
    backgroundImage: null,
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center'
};

const HSection = styled.div`
    margin: 10 -15px;
    padding: 0 15px;
    &:hover {
        background: rgba(0, 0, 0, 0.3);
    }
`;

class PreviewImagePicker extends React.Component {
    static defaultProps = {
        disableTopOverlay: false
    };
    constructor(props, context) {
        super(props, context);

        // parse
        let v = '';
        try {
            v = JSON.parse(props[props.propKey]);
        } catch (e) {
            if (_.isObject(props[props.propKey])) v = props[props.propKey];
            else v = _.extend({}, C_LAYER_DEFAULT, props.default);
        }

        this.state = {
            value: v,
            expanded: false
        };
    }

    componentWillReceiveProps = nextProps => {
        // parse
        let v = '';
        try {
            v = JSON.parse(nextProps[nextProps.propKey]);
        } catch (e) {
            if (_.isObject(nextProps[nextProps.propKey])) v = nextProps[nextProps.propKey];
            else v = _.extend({}, C_LAYER_DEFAULT, nextProps.default);
        }
        // console.log('!CDP !');
    };

    render() {
        const { value, expanded, imagePicker } = this.state;
        const layer = value;

        const uploadPreview = this.state.imageToUpload && this.state.imageToUpload.preview;

        let images = _.sortBy(this.state.userImages, img => {
            return -new Date(img.createdAt);
        });
        images = _.take(images, 8);

        const properyChange = object => {
            this.setState(
                update(this.state, {
                    value: { $merge: object }
                }),
                () => {
                    this.props.onChange(this.props.propKey, this.state.value);
                }
            );
        };

        return (
            <div className="preview-image-picker">
                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                    <TextField
                        floatingLabelFixed
                        floatingLabelText={this.props.label}
                        value={layer.backgroundImage}
                        onBlur={e => {
                            properyChange({ backgroundImage: e.target.value });
                        }}
                        onChange={(e, backgroundImage) =>
                            this.setState(
                                update(this.state, {
                                    value: { $merge: { backgroundImage } }
                                })
                            )
                        }
                    />
                    <FlatButton
                        icon={<IconImages />}
                        style={{ minWidth: '44px', marginLeft: 5 }}
                        onClick={() => {
                            this.setState({ imagePicker: true });
                        }}
                    />
                </div>
                {layer.backgroundImage && <img key="1" style={{ width: '100%' }} src={layer.backgroundImage} />}

                {layer.backgroundImage && (
                    <FlatButton
                        style={{ width: '100%' }}
                        label="Image manipulations"
                        onClick={e =>
                            this.setState({
                                expanded: !expanded,
                                anchorEl: e.target
                            })
                        }
                    />
                )}

                {this.props.plain === true && (
                    <div style={{ margin: 8 }}>
                        <Fields
                            layer={layer}
                            properyChange={properyChange}
                            disableTopOverlay={this.props.disableTopOverlay}
                        />
                    </div>
                )}
                {expanded && (
                    <Popover
                        open={expanded}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                        onRequestClose={() => this.setState({ expanded: false })}
                        style={{ width: 400 }}
                    >
                        <div style={{ padding: 16 }}>
                            <Fields
                                layer={layer}
                                properyChange={properyChange}
                                disableTopOverlay={this.props.disableTopOverlay}
                            />

                            <FlatButton
                                label="Reset"
                                onClick={() => {
                                    const resetTo = _.extend({}, C_LAYER_DEFAULT);
                                    Reflect.deleteProperty(resetTo, 'backgroundImage');
                                    properyChange(resetTo);
                                }}
                            />

                            <FlatButton
                                label="Done"
                                style={{ float: 'right' }}
                                onClick={() => {
                                    this.setState({
                                        expanded: false
                                    });
                                }}
                            />
                        </div>
                    </Popover>
                )}

                {imagePicker && (
                    <ImageUploaderContainer
                        onCopy={url => {
                            this.setState(
                                update(this.state, {
                                    value: {
                                        $merge: { backgroundImage: url }
                                    },
                                    imagePicker: { $set: false }
                                }),
                                () => {
                                    this.props.onChange(this.props.propKey, this.state.value);
                                }
                            );
                        }}
                        onClose={() => {
                            this.setState({
                                imagePicker: null
                            });
                        }}
                        modal
                        galleryFirst
                        cdnOnly
                        cdnLabel="Pick"
                    />
                )}
            </div>
        );
    }
}

const CommonFields = ({ layer, properyChange, disableTopOverlay }) => (
    <div>
        <SelectField
            floatingLabelText={'Image fit'}
            value={layer.backgroundSize}
            key={'backgroundSize'}
            style={{ width: '100%' }}
            onChange={(e, index, backgroundSize) => {
                if (backgroundSize === 'cover') {
                    properyChange({
                        backgroundSize,
                        scale: 1,
                        translateX: 50,
                        translateY: 50,
                        backgroundPositionX: 'center',
                        backgroundPositionY: 'center'
                    });
                } else {
                    // contain
                    properyChange({
                        backgroundSize,
                        scale: 1,

                        translateX: 0,
                        translateY: 0,
                        backgroundPositionX: 'center',
                        backgroundPositionY: 'center'
                    });
                }
            }}
        >
            {/* <MenuItem key={'c0'} value={'initial'} primaryText={'Original size'} /> */}
            <MenuItem key={'c2'} value={'contain'} primaryText={'Contain image in widget'} />
            <MenuItem key={'c1'} value={'cover'} primaryText={'Cover whole widget'} />
        </SelectField>

        {!disableTopOverlay && (
            <Toggle
                label="Top Overlay"
                defaultToggled={layer.topOverlay === true}
                onToggle={(e, isInputChecked) => {
                    properyChange({
                        topOverlay: isInputChecked
                    });
                }}
            />
        )}
    </div>
);

const FieldsForZoomable = ({ layer, properyChange, disableTopOverlay }) => (
    <div>
        <HSection>
            <SelectField
                floatingLabelText={'Horizontal'}
                value={layer.backgroundPositionX}
                key={'backgroundPositionX'}
                style={{ width: 150 }}
                onChange={(e, index, backgroundPositionX) => {
                    properyChange({ backgroundPositionX });
                }}
            >
                {['center', 'left', 'right', 'moveX'].map(o => {
                    return <MenuItem key={o} value={o} primaryText={o} />;
                })}
            </SelectField>

            {layer.backgroundPositionX === 'moveX' && (
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <Slider
                        step={1}
                        min={-1000}
                        max={1000}
                        key="translateX"
                        value={layer.translateX}
                        sliderStyle={{
                            marginBottom: '0px',
                            marginTop: '12px'
                        }}
                        style={{
                            flexGrow: 1,
                            width: '100%',
                            marginRight: 5
                        }}
                        onChange={(e, translateX) => {
                            properyChange({ translateX });
                        }}
                    />
                    <FlatButton
                        label="reset"
                        onClick={() => {
                            properyChange({ translateX: 0 });
                        }}
                    />
                </div>
            )}
        </HSection>
        <HSection>
            <SelectField
                floatingLabelText={'Vertical'}
                value={layer.backgroundPositionY}
                key={'backgroundPositionY'}
                style={{ width: 150 }}
                onChange={(e, index, backgroundPositionY) => {
                    properyChange({ backgroundPositionY });
                }}
            >
                {['center', 'top', 'bottom', 'moveY'].map(o => {
                    return <MenuItem key={o} value={o} primaryText={o} />;
                })}
            </SelectField>

            {layer.backgroundPositionY === 'moveY' && (
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <Slider
                        step={1}
                        min={-1000}
                        max={1000}
                        key="translateY"
                        value={layer.translateY}
                        sliderStyle={{
                            marginBottom: '0px',
                            marginTop: '12px'
                        }}
                        style={{
                            flexGrow: 1,
                            width: '100%',
                            marginRight: 5
                        }}
                        onChange={(e, translateY) => {
                            properyChange({ translateY });
                        }}
                    />
                    <FlatButton
                        label="reset"
                        onClick={() => {
                            properyChange({ translateY: 0 });
                        }}
                    />
                </div>
            )}
        </HSection>
        <Subheader>Scale/Zoom</Subheader>

        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <Slider
                step={0.1}
                min={1}
                max={10}
                key="Scale"
                value={layer.scale}
                sliderStyle={{
                    marginBottom: '0px',
                    marginTop: '12px'
                }}
                style={{
                    flexGrow: 1,
                    width: '100%',
                    marginRight: 5
                }}
                onChange={(e, scale) => {
                    properyChange({ scale });
                }}
            />
            <FlatButton
                label="reset"
                onClick={() => {
                    properyChange({ scale: 1.0 });
                }}
            />
        </div>
    </div>
);

const FieldsForCover = ({ layer, properyChange }) => (
    <div>
        <Subheader key="1">Move X (if landscape)</Subheader>
        <Slider
            step={1}
            min={0}
            max={100}
            key="translateX"
            value={layer.translateX}
            sliderStyle={{
                marginBottom: '0px',
                marginTop: '12px'
            }}
            onChange={(e, translateX) => {
                properyChange({ translateX });
            }}
        />
        <Subheader key="2">Move Y (if portrait)</Subheader>
        <Slider
            step={1}
            min={0}
            max={100}
            key="translateY"
            value={layer.translateY}
            sliderStyle={{
                marginBottom: '0px',
                marginTop: '12px'
            }}
            onChange={(e, translateY) => {
                properyChange({ translateY });
            }}
        />
    </div>
);

const Fields = ({ layer, properyChange, disableTopOverlay }) => {
    const bgrCover = !(layer.backgroundSize === 'contain' || layer.backgroundSize === 'initial');

    return (
        <div>
            <CommonFields layer={layer} properyChange={properyChange} disableTopOverlay={disableTopOverlay} />
            {bgrCover ? (
                <FieldsForCover layer={layer} properyChange={properyChange} disableTopOverlay={disableTopOverlay} />
            ) : (
                <FieldsForZoomable layer={layer} properyChange={properyChange} disableTopOverlay={disableTopOverlay} />
            )}

            <Subheader>Opacity</Subheader>
            <Slider
                step={0.1}
                min={0.1}
                max={1}
                key="Opacity"
                value={layer.opacity}
                sliderStyle={{
                    marginBottom: '0px',
                    marginTop: '12px'
                }}
                onChange={(e, opacity) => {
                    properyChange({ opacity });
                }}
            />
        </div>
    );
};

export default PreviewImagePicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/PreviewImagePicker.js
 **/